<template>
  <section>
    <div v-if="isShowSelector" class="form-inline mb-3">
      <div class="form-group">
        <label class="control-label mr-2">Sito: </label>
        <select class="form-control" v-model="selectedSiteId">
          <option :value="null">Tutti</option>
          <option v-for="site in sites"
                  :key="site.guid"
                  :value="site.guid">
            {{ site.name }}
          </option>
        </select>
      </div>
    </div>

    <DashboardMono v-if="isShowMono" />
    <DashboardMulti v-else />

  </section>
</template>

<script>
import DashboardMono from "@/components/DashboardMono";
import DashboardMulti from "@/components/DashboardMulti";
import { mapState, mapMutations } from "vuex";

export default {
  components: {
    DashboardMono,
    DashboardMulti,
  },

  computed: {
    ...mapState({
      user: state => state.user,
      stateSelectedSiteId: state => state.selectedSiteId,
    }),

    sites() {
      const sites = 'sites' in this.user ? this.user.sites : [];
      return sites.filter((site) => site.guid);
    },

    isShowSelector() {
      return this.sites.length > 1;
    },

    isShowMono() {
      return this.isSelectedSiteId || !this.isShowSelector;
    },

    isSelectedSiteId() {
      return !!this.selectedSiteId;
    },

    selectedSiteId: {
      get() {
        return this.stateSelectedSiteId;
      },
      set(value) {
        this.setSelectedSiteId(value);
      }
    }
  },

  watch: {
    sites: {
      deep: true,
      handler(sites) {
        if (sites.length > 1) {
          return;
        }

        this.selectedSiteId = sites[0].guid;
      }
    }
  },

  methods: {
    ...mapMutations({
      setSelectedSiteId: 'setSelectedSiteId',
    }),
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TheDashboardPage.vue